import { render, staticRenderFns } from "./DisabilityInfo.vue?vue&type=template&id=3499b82c&"
import script from "./DisabilityInfo.vue?vue&type=script&lang=js&"
export * from "./DisabilityInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports